module.exports = __webpack_public_path__ + "static/media/magic_rule_background.cd7886db.jpg";